import { COLORS } from "@coeff/utils";
import React from "react";
import styled from "styled-components";

import { DEPRECATED_Button, ButtonProps } from "./DEPRECATED_Button";

export interface GraphicsProps {
  className?: string;
  graphics: React.ReactNode;
  title: string | React.ReactNode;
  description?: string | React.ReactNode;
  descriptionStyle?: React.CSSProperties;
  buttonProps?: ButtonProps;
  buttonText?: string | React.ReactChild;
  descriptionHtml?: string;
}

const GraphicsWrap = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;

  .graphicsLogo {
    display: flex;
    margin: 20px auto;

    > svg:first-child {
      margin: 10px 10px 10px 0px;
    }
  }

  .title {
    text-align: center;
    color: ${COLORS.black85};
    margin: 12px auto 0px;
  }

  > div {
    margin: 10px 0px 30px;
    text-align: center;
    color: ${COLORS.black45};
    max-width: 85%;
  }
`;

const StyledButton = styled(DEPRECATED_Button)`
  && {
    line-height: 2;
    width: 200px;
  }
`;

export const Graphics = ({
  graphics,
  title,
  description,
  buttonProps,
  buttonText,
  descriptionHtml,
  descriptionStyle,
  ...props
}: GraphicsProps) => {
  return (
    <GraphicsWrap {...props}>
      {graphics}
      <h3 className="title">{title}</h3>
      {description && <div style={descriptionStyle}>{description}</div>}
      {descriptionHtml && <div dangerouslySetInnerHTML={{ __html: descriptionHtml }} />}
      {buttonText && (
        <StyledButton type="primary" {...buttonProps}>
          {buttonText}
        </StyledButton>
      )}
    </GraphicsWrap>
  );
};
